import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LogoutButton from "./LogoutButton";
import FloatingNavbarMobile from "./floatingNavbarMobile";
import FloatingNavbarDesktop from "./FloatingNavbarDesktop";
import "./Navbar.css";
import "../Home.css";
import logo from "../../assets/kazhavda-logo-white.png";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

function Navbar() {
  const { authPayload } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showFloatingNav, setShowFloatingNav] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const isAuthenticated = Boolean(authPayload?.id_token);
  const floatingLinks = [
    { to: "/profile", label: "Профил" },
    { to: "/invitations", label: "Покани" },
    { to: "/organizer", label: "Организатор" },
    { to: "/photos", label: "Фотографии" },
  ];

  useEffect(() => {
    setMenuOpen(false);
  }, [authPayload, location]);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingNav(window.scrollY > 80);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="home-container">
      <nav className="navbar">
        <div className="logo-container">
          <Link to="/">
            <img src={logo} alt="Logo" className="navbar-logo" />
          </Link>
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? (
            <CloseIcon fontSize="large" />
          ) : (
            <MenuIcon fontSize="large" />
          )}
        </div>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          {authPayload?.id_token ? (
            <>
              <Link to="/profile" className="nav-link" onClick={toggleMenu}>
                Профил
              </Link>
              <Link to="/invitations" className="nav-link" onClick={toggleMenu}>
                Покани
              </Link>
              <Link to="/organizer" className="nav-link" onClick={toggleMenu}>
                Организатор
              </Link>
              <Link to="/photos" className="nav-link" onClick={toggleMenu}>
                Фотографии
              </Link>
              {authPayload?.role === "admin" ? (
                <Link to="/dashboard" className="nav-link" onClick={toggleMenu}>
                  Админ панел
                </Link>
              ) : null}
              <LogoutButton />
            </>
          ) : (
            <>
              <Link to="/articles" className="nav-link" onClick={toggleMenu}>
                Статии
              </Link>
              <Link to="/login" className="nav-link" onClick={toggleMenu}>
                Најави се
              </Link>
              <Link
                to="https://backoffice.kazhavda.mk"
                className="nav-link"
                target="_blank"
                onClick={toggleMenu}
              >
                Бизнис соработка
              </Link>
            </>
          )}
        </div>
      </nav>

      {isAuthenticated && showFloatingNav && !menuOpen ? (
        <>
          <FloatingNavbarDesktop
            links={floatingLinks}
            currentPath={location.pathname}
          />
          <FloatingNavbarMobile
            links={floatingLinks}
            currentPath={location.pathname}
          />
        </>
      ) : null}
    </div>
  );
}

export default Navbar;
